import React from "react";
import Header from "./components/Header";

import Home from "./Pages/Index";

function App() {
  return (
    <div>
      <Header />
      <Home />
    </div>
  );
}

export default App;
